module.exports = __webpack_public_path__ + "img/violet_061.a509f436.png";